<template lang='pug'>
  .variant-carousel(v-if='variants.length > 0')
    .carousel-banner(v-if='carousel.attributes["banner-image-url"]')
      a(v-if='carousel.attributes["banner-image-link"]' :href='carousel.attributes["banner-image-link"]')
        img(:src='carousel.attributes["banner-image-url"]' :alt='carousel.attributes["banner-image-alt-text"]')
      img(v-else :src='carousel.attributes["banner-image-url"]' :alt='carousel.attributes["banner-image-alt-text"]')

    slider(
      carouselType='variant'
      :containerClass='containerClass'
      :autoplay='false'
      :items='4'
      :slideBy='4'
      :speed='300'
      :nav='false'
      :showArrows='true'
      :responsiveOptions='responsiveOptions'
      @indexChanged='indexChangedCallback'
    )
      .wrapper(slot='slider-content')
        .variant-sliders(:class='containerClass' v-if='variants.length > 0')
          span(v-for='variant in variants')
            variant-card(:variant='variant')
    .clearfix

    .carousel-button(v-if='carousel.attributes.url')
      a.carousel-link.button.btn.btn-white(v-t='"buttonText"' :href='carousel.attributes.url')
</template>

<i18n>
{
  "lng_en": {
    "buttonText": "See all products"
  },
  "lng_id": {
    "buttonText": "Lihat semua produk"
  },
  "lng_th": {
    "buttonText": "ดูสินค้าทั้งหมด"
  },
  "lng_zh": {
    "buttonText": "查看全部產品"
  },
  "lng_ko": {
    "buttonText": "전체 상품 보기"
  }
}
</i18n>

<script>
import VariantCard from './variant-card.vue'
import Slider from '../../shared/slider.vue'
import { mapState } from 'vuex'

export default {
  components: {
    VariantCard,
    Slider
  },

  props: {
    carousel: {
      type: Object,
      required: true
    },
    items: {
      type: Number,
      default: 4,
      required: false
    },
    slideBy: {
      type: Number,
      required: false
    },
    indexChangedCallback: {
      type: Function
    }
  },

  data () {
    return {
      variants: []
    }
  },

  computed: {
    ...mapState({
      landingPageIncluded: state => state.landingPage.landingPageIncluded
    }),
    isMobile: () => vueSupport.isMobile,
    isTablet: () => vueSupport.isTablet,
    containerClass () {
      return `carousel-${this.carousel.id}`
    },
    responsiveOptions () {
      return {
        0: { // Mobile
          autoplay: false,
          mouseDrag: true,
          items: 2,
          slideBy: 2
        },
        576: { // Tablet Portrait
          autoplay: false,
          mouseDrag: true,
          items: this.items,
          slideBy: this.slideByCalc
        },
        992: { // Laptop & Tablet Landscape
          autoplay: false,
          mouseDrag: this.isTablet,
          items: this.items,
          slideBy: this.slideByCalc
        }
      }
    },
    slideByCalc () {
      if (this.slideBy !== undefined) return this.slideBy
      return (this.variants.length > 12) ? this.items : 1
    }
  },

  mounted () {
    if (this.$route.name === 'beautyfeed-show') {
      this.variants = this.carousel.variants
    } else {
      const relationships = this.carousel.relationships.variants.data
      const variants = relationships.map((item) => this.landingPageIncluded.find((included) => included.type === item.type && included.id === item.id))
      for (const index in variants) {
        if (variants[index].attributes['sold-out']) {
          variants.push(variants.splice(index, 1)[0])
        }
      }
      this.variants = variants
    }
  }
}
</script>

<style lang='scss' scoped>
  img {
    width: 100%;
  }

  .carousel-button {
    text-align: center;
    padding-top: 15px;
    padding-bottom: 15px;
  }
</style>
